/* Publish by EComposer at 2026-10-14 13:02:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-znh9wuaxfra"]=  window.__ectimmers["ecom-znh9wuaxfra"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-znh9wuaxfra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znh9wuaxfra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urr29b163w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urr29b163w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v9g86k8u1sd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v9g86k8u1sd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-daiu5ntsn16').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-daiu5ntsn16', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2u7yu1py022').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2u7yu1py022', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-en4mrjlit3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-en4mrjlit3d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fhzk41vt7j7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fhzk41vt7j7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8fqrx0fn2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8fqrx0fn2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yel6ch6du5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yel6ch6du5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n0yh70jn4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0yh70jn4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mz1y2k0ig2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mz1y2k0ig2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ru5ovadvw3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ru5ovadvw3', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m8881pftxgp"]=  window.__ectimmers["ecom-m8881pftxgp"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-m8881pftxgp"]["xdz3dw6o6"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-m8881pftxgp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8881pftxgp', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-284ebv24bsa"]=  window.__ectimmers["ecom-284ebv24bsa"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-284ebv24bsa"]["o59s61dtt"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-284ebv24bsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-284ebv24bsa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0d4m19rq2np5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0d4m19rq2np5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5irortalh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5irortalh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gz8wdeaqp1t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gz8wdeaqp1t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0qnm6i0ccs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0qnm6i0ccs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-euhg3hddivl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-euhg3hddivl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2wksritzzlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wksritzzlo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sf98btnnjkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sf98btnnjkk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4trofhd3ip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4trofhd3ip', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wenfkanayg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wenfkanayg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-261qr8yntp2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-261qr8yntp2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhig0azhdz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhig0azhdz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0li201i8uc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0li201i8uc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f6hlwlc6w4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f6hlwlc6w4r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgz9dz1yknq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgz9dz1yknq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9m317era3z7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9m317era3z7', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3y9e9fr80qy"]=  window.__ectimmers["ecom-3y9e9fr80qy"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+e);n.length&&n.forEach(function(r){const a=r.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const l=r.querySelector("video");l!=null&&l.pause()})},s=function(n){if(window.EComModal)return n();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&n()});return}let r=0;const a= window.__ectimmers["ecom-3y9e9fr80qy"]["v68ugk4w4"] = setInterval(function(){window.EComModal?(clearInterval(a),n()):++r>=300&&clearInterval(a)},50)},o=this.id;t&&s(function(){var n=t.querySelector("[ecom-modal]");new window.EComModal(n,{cssClass:["ecom-container-lightbox-"+o,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const r=document.querySelectorAll(".ecom-container-lightbox-"+e);r.length&&(r.forEach(function(a){const l=a.querySelector("iframe");if(l!=null){const d=l.src.replace("muted=1","muted=0").replace("mute=1","mute=0");l.src=d}const c=a.querySelector("video");c!=null&&c.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:r}})))},onClose:i})}),i()

                    });
                    
                        document.querySelectorAll('.ecom-3y9e9fr80qy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3y9e9fr80qy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxjhlx1buf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxjhlx1buf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yw9dsa0fflb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yw9dsa0fflb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iespr44jin').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iespr44jin', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9435uj3vy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9435uj3vy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtjpsye0ccc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtjpsye0ccc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-586uvta5h6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-586uvta5h6b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qf09nm049ll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qf09nm049ll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ez1cgvkv3sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ez1cgvkv3sq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yt2gtjzlnt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yt2gtjzlnt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jm31f0py87').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jm31f0py87', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lqyv6zyfdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lqyv6zyfdc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clls3ax5lw6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clls3ax5lw6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51s9oxfip2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51s9oxfip2w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94aw7qi4kug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94aw7qi4kug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5u99uq60g6w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5u99uq60g6w', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}